module.exports = __webpack_public_path__ + "img/group-chat2.03a5de59.png";